import React, { useState } from 'react';
import pb from '../../services/pocketbase';
import Modal from '../Modal/Modal';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import './AdminDashboard.css';

function EventManager({ events, onEventAdded, onEventUpdated, onEventDeleted }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [editingEvent, setEditingEvent] = useState(null);

    const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    const eventData = editingEvent || currentEvent;

    if (name === 'image') {
      if (editingEvent) {
        setEditingEvent({ ...editingEvent, [name]: files[0] });
      } else {
        setCurrentEvent({ ...currentEvent, [name]: files[0] });
      }
    } else {
      if (editingEvent) {
        setEditingEvent({ ...editingEvent, [name]: value });
      } else {
        setCurrentEvent({ ...currentEvent, [name]: value });
      }
    }
  };

    const handleCancel = () => {
    setIsModalOpen(false);
    setEditingEvent(null);
    setCurrentEvent(null);
  };

    const showAddModal = () => {
    setEditingEvent(null);
    setCurrentEvent({ title: '', description: '', start_date: '', end_date: '', location: '', image: null });
    setIsModalOpen(true);
  };

    const showEditModal = (event) => {
    const formatForInput = (dateString) => {
      if (!dateString) return '';
      try {
        return new Date(dateString).toISOString().slice(0, 16);
      } catch (e) {
        return '';
      }
    };

    setEditingEvent({
      ...event,
      start_date: formatForInput(event.start_date),
      end_date: formatForInput(event.end_date),
      image: null, // Keep file input empty for edits
    });
    setCurrentEvent(null);
    setIsModalOpen(true);
  };

    const handleDelete = async (eventId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cet événement ?")) {
      try {
        await pb.collection('events').delete(eventId);
        onEventDeleted(eventId);
        alert('Événement supprimé avec succès !');
      } catch (error) {
        console.error("Failed to delete event:", error);
        alert("Erreur lors de la suppression de l'événement.");
      }
    }
  };

    const handleSubmit = async (e) => {
    e.preventDefault();
    const eventData = editingEvent || currentEvent;
    const formData = new FormData();

    Object.keys(eventData).forEach(key => {
      if (key !== 'id' && key !== 'image' && eventData[key] !== null) {
        if (key === 'start_date' || key === 'end_date') {
          if(eventData[key]) formData.append(key, new Date(eventData[key]).toISOString());
        } else {
          formData.append(key, eventData[key]);
        }
      }
    });

    if (eventData.image instanceof File) {
      formData.append('image', eventData.image);
    }

    try {
      if (editingEvent) {
        const updatedRecord = await pb.collection('events').update(editingEvent.id, formData);
        onEventUpdated(updatedRecord);
        alert('Événement mis à jour !');
      } else {
        const newRecord = await pb.collection('events').create(formData);
        onEventAdded(newRecord);
        alert('Événement ajouté !');
      }
      handleCancel();
    } catch (error) {
      console.error('Failed to save event:', error);
      alert("Erreur lors de l'enregistrement de l'événement.");
    }
  };

    const renderEventForm = () => {
    const eventData = editingEvent || currentEvent;
    if (!eventData) return null;

    return (
      <form onSubmit={handleSubmit} className="dashboard-form">
        <div className="form-group">
          <label>Titre</label>
          <input type="text" name="title" value={eventData.title} onChange={handleInputChange} placeholder="Titre de l'événement" required />
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea name="description" value={eventData.description} onChange={handleInputChange} placeholder="Description"></textarea>
        </div>
        <div className="form-group">
          <label>Date de début</label>
          <input type="datetime-local" name="start_date" value={eventData.start_date} onChange={handleInputChange} required />
        </div>
        <div className="form-group">
          <label>Date de fin (optionnel)</label>
          <input type="datetime-local" name="end_date" value={eventData.end_date} onChange={handleInputChange} />
        </div>
        <div className="form-group">
          <label>Lieu</label>
          <input type="text" name="location" value={eventData.location} onChange={handleInputChange} placeholder="Lieu" />
        </div>
        <div className="form-group">
          <label>Image</label>
          <input type="file" name="image" onChange={handleInputChange} />
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-primary">{editingEvent ? 'Mettre à jour' : 'Ajouter'}</button>
          <button type="button" onClick={handleCancel} className="btn-secondary">Annuler</button>
        </div>
      </form>
    );
  };

    return (
    <div className="event-manager">
      <div className="list-header">
        <h4>Gestion de l'Agenda</h4>
        <button onClick={showAddModal}>Ajouter un événement</button>
      </div>

      <div className="dashboard-table-container">
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Titre</th>
              <th>Date de début</th>
              <th>Lieu</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {events && events.length > 0 ? events.map(event => (
              <tr key={event.id}>
                <td>
                  {event.image ? (
                    <img src={pb.files.getURL(event, event.image)} alt={event.title} className="table-thumbnail" />
                  ) : (
                    <div className="table-thumbnail-placeholder">?</div>
                  )}
                </td>
                <td>{event.title}</td>
                <td>{new Date(event.start_date).toLocaleString('fr-FR')}</td>
                <td>{event.location}</td>
                <td>
                  <div className="item-actions">
                    <button onClick={() => showEditModal(event)} className='edit-btn' title="Modifier"><FaPencilAlt /></button>
                    <button onClick={() => handleDelete(event.id)} className='delete-btn' title="Supprimer"><FaTrash /></button>
                  </div>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="5">Aucun événement à afficher.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCancel}
        title={editingEvent ? 'Modifier l\'événement' : 'Ajouter un événement'}
      >
        {renderEventForm()}
      </Modal>
    </div>
  );
}

export default EventManager;
